import React, { useState } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import AddToPlaylist from "../Icons/AddToPlaylist.svg";
import Play from "../Icons/Play.svg";

const getHostName = (link) => {
  if (link) {
    const doc = document.createElement("a");
    doc.href = (link.startsWith("http") ? "" : "http://") + link;
    return doc.hostname;
  }
};

const estimatedMinutes = (numCharacters) =>
  Math.round(((numCharacters / 36000) * 60) / 2);

const Article = observer(
  ({ article, trackingId, addArticleToPlaylist, selectArticle }) => {
    const {
      article_id,
      title,
      date,
      date_added,
      num_characters,
      thumbnail_url,
    } = article;

    const articleDate = new Date(date || date_added);
    const [isHovering, setIsHovering] = useState(false);

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return (
      <div className="similar-article-card">
        <div
          className="article-background-img"
          style={{
            backgroundImage: `url(${thumbnail_url})`,
          }}
        ></div>
        <div className="article-similar">
          <div
            className="thumbnail"
            onMouseEnter={(e) => {
              setIsHovering(true);
            }}
            onMouseLeave={(e) => {
              setIsHovering(false);
            }}
          >
            {thumbnail_url ? (
              <img src={thumbnail_url} onClick={() => selectArticle(article)} />
            ) : null}
            <div
              style={{
                opacity: isHovering ? 1 : 0,
              }}
              className="floating-play-icon-container"
              onClick={() => selectArticle(article)}
            >
              <img id="floating-play-icon-svg" src={Play} />
            </div>
          </div>
          <div>
            <div
              className="title"
              onClick={() => selectArticle(article)}
              onMouseEnter={(e) => {
                setIsHovering(true);
              }}
              onMouseLeave={(e) => {
                setIsHovering(false);
              }}
            >
              {title}
            </div>
            <div className="author">
              <a href={`http://${article_id}`} target="_blank" className="link">
                {getHostName(article_id)}
              </a>
            </div>
            <div className="time">{estimatedMinutes(num_characters)} min</div>
          </div>
        </div>
      </div>
    );
  }
);

export default Article;
